import { Button, Flex, Typography, Upload } from 'antd';
import type { ButtonProps } from 'antd';
import styled from 'styled-components';

import { InboxOutlined } from '@ant-design/icons';

import { toCssUrl } from 'src/utils/sanitize';

export const StyledUploadWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  min-width: 0;
`;

export const LoadingWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  min-height: 48px;
`;

export const StyledDragger = styled(Upload.Dragger)`
  width: 100%;
  border-radius: 4px;
`;

export const FilePreview = styled.div`
  max-width: 100%;
`;

export const FileDescription = styled(Typography.Text)`
  color: ${({ theme }) => theme.colorTextDescription};
  margin-top: 2px;
  display: block;
`;

export const IconWrapper = styled.div`
  color: #00a76f;
`;

export const PreviewContainer = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colorBorder};
  border-radius: 8px;
  padding: 8px;
  width: 100%;
  overflow: hidden;
  min-width: 0;
  flex-direction: row;
`;

export const PreviewContent = styled(Flex).attrs({
  align: 'center',
  justify: 'flex-start',
  gap: '16px',
})`
  width: 100%;
`;

export const PreviewImageContainer = styled(Flex).attrs({
  align: 'center',
  gap: 12,
})`
  flex-shrink: 0;
`;

export const PreviewImage = styled.div<{ $hasImage: boolean; $preview?: string }>`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  flex-shrink: 0;
  ${({ $hasImage, $preview, theme }) =>
    $hasImage
      ? `
    background-image: ${toCssUrl($preview ?? '')};
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  `
      : `
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colorFillQuaternary};
  `}
`;

export const PreviewButton = styled(Button).attrs(
  (): Pick<ButtonProps, 'type'> => ({
    type: 'text',
  }),
)`
  svg {
    height: 22px;
    width: 22px;
    color: ${({ theme }) => theme.colorTextDescription};
  }
`;

export const FileNameTextWrapper = styled(Flex).attrs({
  align: 'center',
  flex: 1,
  justify: 'space-between',
})`
  min-width: 0;
  overflow: hidden;
`;

export const FileNameText = styled(Typography.Text)<{ $textWidth?: number }>`
  color: ${({ theme }) => theme.colorPrimary};
  padding-left: 24px;
  ${({ $textWidth }) => $textWidth && `max-width: ${$textWidth}px;`}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
`;

export const InboxIcon = styled(InboxOutlined)`
  font-size: 32px;
  color: ${({ theme }) => theme.colorPrimary};
`;

export const PreviewWrapper = styled.div`
  width: 100%;
`;

export const FileNameTextContent = styled(Flex).attrs({
  flex: 1,
})`
  min-width: 0;
  overflow: hidden;
`;

export const DisplayNameWrapper = styled.div.attrs<{ $textWidth?: number }>(({ $textWidth }) => ({
  style: {
    maxWidth: `${$textWidth ?? 200}px`,
  },
}))`
  color: ${({ theme }) => theme.colorPrimary};
  padding-left: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const ButtonsWrapper = styled(Flex).attrs({
  align: 'center',
  gap: 8,
})`
  flex-shrink: 0;
`;
